export const azureCostConstants = {
  GET_REQUEST: "GET_AZURE_COST_REQUEST",
  GET_SUCCESS: "GET_AZURE_COST_SUCCESS",
  GET_FAILURE: "GET_AZURE_COST_FAILURE",

  GET_BY_ID_REQUEST: "GET_AZURE_COST_BY_ID_REQUEST",
  GET_BY_ID_SUCCESS: "GET_AZURE_COST_BY_ID_SUCCESS",
  GET_BY_ID_FAILURE: "GET_AZURE_COST_BY_ID_FAILURE",

  CREATE_REQUEST: "CREATE_AZURE_COST_REQUEST",
  CREATE_SUCCESS: "CREATE_AZURE_COST_SUCCESS",
  CREATE_FAILURE: "CREATE_AZURE_COST_FAILURE",

  UPDATE_REQUEST: "UPDATE_AZURE_COST_REQUEST",
  UPDATE_SUCCESS: "UPDATE_AZURE_COST_SUCCESS",
  UPDATE_FAILURE: "UPDATE_AZURE_COST_FAILURE",

  DELETE_REQUEST: "DELETE_AZURE_COST_REQUEST",
  DELETE_SUCCESS: "DELETE_AZURE_COST_SUCCESS",
  DELETE_FAILURE: "DELETE_AZURE_COST_FAILURE",

  BULK_UPSERT_REQUEST: "BULK_UPSERT_AZURE_COST_REQUEST",
  BULK_UPSERT_SUCCESS: "BULK_UPSERT_AZURE_COST_SUCCESS",
  BULK_UPSERT_FAILURE: "BULK_UPSERT_AZURE_COST_FAILURE",

  GET_DAILY_REQUEST: "GET_AZURE_COST_DAILY_REQUEST",
  GET_DAILY_SUCCESS: "GET_AZURE_COST_DAILY_SUCCESS",
  GET_DAILY_FAILURE: "GET_AZURE_COST_DAILY_FAILURE",

  GET_MONTHLY_REQUEST: "GET_AZURE_COST_MONTHLY_REQUEST",
  GET_MONTHLY_SUCCESS: "GET_AZURE_COST_MONTHLY_SUCCESS",
  GET_MONTHLY_FAILURE: "GET_AZURE_COST_MONTHLY_FAILURE",

  GET_QUARTERLY_REQUEST: "GET_AZURE_COST_QUARTERLY_REQUEST",
  GET_QUARTERLY_SUCCESS: "GET_AZURE_COST_QUARTERLY_SUCCESS",
  GET_QUARTERLY_FAILURE: "GET_AZURE_COST_QUARTERLY_FAILURE",

  GET_SUBSCRIPTIONS_REQUEST: "GET_AZURE_COST_SUBSCRIPTIONS_REQUEST",
  GET_SUBSCRIPTIONS_SUCCESS: "GET_AZURE_COST_SUBSCRIPTIONS_SUCCESS",
  GET_SUBSCRIPTIONS_FAILURE: "GET_AZURE_COST_SUBSCRIPTIONS_FAILURE",

  // Chart data (larger datasets)
  GET_CHART_DATA_REQUEST: "GET_AZURE_COST_CHART_DATA_REQUEST",
  GET_CHART_DATA_SUCCESS: "GET_AZURE_COST_CHART_DATA_SUCCESS",
  GET_CHART_DATA_FAILURE: "GET_AZURE_COST_CHART_DATA_FAILURE",
};
